import React from 'react'
import styled from '@emotion/styled'
import {AnimatePresence, motion} from 'motion/react'

import {Button} from '@vio/atlas/Button'
import {Icon} from '@vio/atlas/Icon'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

interface Props {
  onClick: () => void
  enabled: boolean
}

const ButtonsWrapper = styled.div`
  position: absolute;
  display: inline-block;
  right: ${cssTheme.layout.spacing.s300};
  bottom: ${cssTheme.layout.spacing.s600};
  ${linariaMq.desktopXs} {
    right: ${cssTheme.layout.spacing.s500};
    bottom: ${cssTheme.layout.spacing.s700};
  }
`

const StickyWrapper = styled.div`
  position: sticky;
  bottom: 0;
  will-change: transform;
  z-index: 1;
`

export const ReviewsBackToTopButton = ({onClick, enabled = true}: Props) => {
  const onBackToTopClick = () => {
    onClick()
  }

  return (
    <StickyWrapper>
      <AnimatePresence>
        {enabled && (
          <motion.div
            key="backToTop"
            initial={{opacity: 0, y: 100}}
            animate={{opacity: 1, y: 0}}
            exit={{opacity: 0, y: 100}}
            transition={{
              duration: 0.15
            }}
          >
            <ButtonsWrapper>
              <Button
                isRounded
                isFloating
                variant="tertiary"
                onClick={onBackToTopClick}
                iconStart={<Icon name="ArrowUp" />}
              />
            </ButtonsWrapper>
          </motion.div>
        )}
      </AnimatePresence>
    </StickyWrapper>
  )
}
